/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { LanguageInitializationService } from '@app/_shared/service/language-initialization.service';
import { customizeSentryBreadcrumbs } from '@app/_shared/support/functions/customizeSentryBreadcrumbs';
import { environment } from '@env/environment';
import * as Sentry from '@sentry/angular';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Initialize language as early as possible
const initialLanguage = LanguageInitializationService.completeLanguageInitialization();

Sentry.init({
  beforeBreadcrumb: customizeSentryBreadcrumbs,
  dsn: environment.sentry,
  environment: environment.environment,
  release: `${environment.version}`,
});

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
